membershipApp.directive('datepicker', ['$translate', function ($translate) {
	return {
		link: function ($scope, el, attr, ngModel) {

			function setCookie(key, value) {
				var val = value;
				var expires = new Date();
				expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
				document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
				if (val != "true") {
					$('body').addClass('pound-currency');
				} else {
					$('body').removeClass('pound-currency');
				}
			}


			function getCookie(key) {
				var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
				return keyValue ? keyValue[2] : null;
			}

			var today = new Date();
			var datepicker = $(el);
			var lastDate = getCookie('setDate');
			var isMembDatepicker = datepicker.is('#membdatepicker');


			datepicker.datepicker({
				changeMonth: true,
				changeYear: true,
				yearRange: "1920:2040",
				numberOfMonths: 1,
				onSelect: function (dateText, inst) {
					$scope.currentLang = $translate.proposedLanguage() || $translate.use();
					var date = $(this).val();

					if ($scope.gym[0].Culture != 'en-US') {
						var res = date.split("/");
						var date = res[1] + '/' + res[0] + '/' + res[2];
					}
					$scope.cardStartDate = new Date(date);
					$scope.membershipStartDate = $scope.cardStartDate;

					if ($('.section-authorize').length && !$('#RegBirthdayVal').is(':checked')) {
						$('#RegBirthdayVal').trigger('click');
					}
					
					if ( isMembDatepicker ) {
						$scope.theChoosenMembershipDate = $scope.cardStartDate;
						$scope.getTerms();
					}
					

					if($scope.currentCard.ActivatePromotion && ( $scope.cardStartDate >= new Date($scope.currentCard.StartPromoPeriod) && $scope.cardStartDate <= new Date($scope.currentCard.EndPromoPeriod)) ){
						// console.log($scope.currentCard.PromoPrice);
						$scope.currentCard.currentPrice = $scope.currentCard.PromoPrice
					}else{
						$scope.currentCard.currentPrice = $scope.currentCard.OriginalPrice
					}
					$scope.$apply();
				}
			});

			$('.ui-datepicker').addClass('notranslate');
			$scope.currentLang = $translate.proposedLanguage() || $translate.use();

			// $(window).on('load', function () {
				if ($('.membershipbuy-wrapper').length) {

					if (lastDate != null && lastDate != '') {
	
						if ($scope.gym[0].Culture != 'en-US') {
							var res = lastDate.split('/');
							var newDate = res[1] + '/' + res[0] + '/' + res[2];
							var newLastDate = new Date(newDate);
						}
						else {
							var newLastDate = new Date(lastDate);
						}
	
						datepicker.datepicker("setDate", newLastDate);
						if (datepicker.parents('.membersip-card').is('.checked')) {
							setCookie('setDate', '');
						}
					} else {
						datepicker.datepicker("option", "minDate", 0);
						datepicker.datepicker("setDate", today);
					}
	
					if($scope.membershipSettings && $scope.membershipSettings.MembershipAheadPurchase > 0){
						datepicker.datepicker("option", "maxDate", $scope.membershipSettings.MembershipAheadPurchase);
					}
				}
	
				if ( isMembDatepicker ) {
					datepicker.datepicker("option", "minDate", 0);
					datepicker.datepicker("setDate", today);
					$scope.theChoosenMembershipDate = today;
	
					// if($scope.theChoosenMembership.FixedDate){
					// 	$scope.theChoosenMembershipDate = new Date($scope.theChoosenMembership.FixedStartingDate);
					// }
					// if ( $scope.lockMembership && ( !$scope.theChoosenMembership || !$scope.theChoosenMembership.FixedDate)) {
					// 	datepicker.datepicker("option", "maxDate", $scope.settings.MembershipAheadPurchase);
					// }
	
					if($scope.settings.MembershipAheadPurchase > 0){
						datepicker.datepicker("option", "maxDate", $scope.settings.MembershipAheadPurchase);
					}
				}
	
				if(($scope.card && $scope.card.FixedDate) || ($scope.theChoosenMembership && $scope.theChoosenMembership.FixedDate)){
					let date = $scope.card ? $scope.card.FixedStartingDate : $scope.theChoosenMembership.FixedStartingDate;
					datepicker.datepicker('setDate', new Date(date));
					datepicker.datepicker('disable');
				}
				
				if ($('.section-authorize').length) {
					datepicker.datepicker("option", "maxDate", 0);
				}
	
				datepicker.next('i').on('click', function () {
					datepicker.datepicker('show');
				});
	
	
				if ($scope.currentLang == 'en') {
					if(gym[0].Culture == 'en-GB'){
						datepicker.datepicker("option", $.datepicker.regional['en-GB']);
					}else{
						datepicker.datepicker("option", $.datepicker.regional['en']);
					}
				}else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc' || $scope.currentLang == 'esm'){
					datepicker.datepicker("option", $.datepicker.regional['es']);
				}else if ($scope.currentLang == 'pt'){
					datepicker.datepicker("option", $.datepicker.regional['pt']);
				}else if ($scope.currentLang == 'it'){
					datepicker.datepicker("option", $.datepicker.regional['it']);
				}else if ($scope.currentLang == 'ro'){
					datepicker.datepicker("option", $.datepicker.regional['ro']);
				}else if ($scope.currentLang == 'lt'){
					datepicker.datepicker("option", $.datepicker.regional['lt']);
				}else if ($scope.currentLang == 'id'){
					datepicker.datepicker("option", $.datepicker.regional['id']);
				}else if ($scope.currentLang == 'de'){
					datepicker.datepicker("option", $.datepicker.regional['de']);
				}else if ($scope.currentLang == 'mk'){
					datepicker.datepicker("option", $.datepicker.regional['mk']);
				}else {
					datepicker.datepicker("option", $.datepicker.regional['bg']);
				}
	
				if ( $scope.gym[0].Culture == 'en-US' ) {
					datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
				}else{
					datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
				}
			// });

			$(document).on('click', '.lang-nav li a', function () {
				var lang = $(this).data('lang');

				if (lang == 'en') {
					if(gym[0].Culture == 'en-GB'){
						datepicker.datepicker("option", $.datepicker.regional['en-GB']);
					}else{
						datepicker.datepicker("option", $.datepicker.regional['en']);
					}
				}else if (lang == 'es' || lang == 'esc' || lang == 'esm'){
					datepicker.datepicker("option", $.datepicker.regional['es']);
				}else if (lang == 'pt'){
					datepicker.datepicker("option", $.datepicker.regional['pt']);
				}else if (lang == 'it'){
					datepicker.datepicker("option", $.datepicker.regional['it']);
				}else if (lang == 'ro'){
					datepicker.datepicker("option", $.datepicker.regional['ro']);
				}else if (lang == 'lt'){
					datepicker.datepicker("option", $.datepicker.regional['lt']);
				}else if (lang == 'id'){
					datepicker.datepicker("option", $.datepicker.regional['id']);
				}else if (lang == 'de'){
					datepicker.datepicker("option", $.datepicker.regional['de']);
				}else if (lang == 'mk'){
					datepicker.datepicker("option", $.datepicker.regional['mk']);
				}else {
					datepicker.datepicker("option", $.datepicker.regional['bg']);
				}

				if ( $scope.gym[0].Culture == 'en-US' ) {
					datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
				}else{
					datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
				}
			})
		}
	};
}]);